module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "quick-add mid-align"
  }, [(_vm.isVisitor) ? _vm._h('ul', {
    staticClass: "clearfix margin-15 font-12"
  }, [_vm._h('li', [_vm._h('a', {
    staticClass: "quick-teacher",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["添加老师"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "quick-kids",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["添加学生 / 家长"])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-hostcenter",
    attrs: {
      "to": {
        path: '/user/center/hostTeacherRegister'
      }
    }
  }), _vm._h('span', ["新建园点"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "quick-dynamic",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["发布动态"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "quick-food",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["发布伙食"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "quick-rollcall",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }), _vm._h('span', ["发起点名"])])]) : _vm._h('ul', {
    staticClass: "clearfix margin-15 font-12"
  }, [_vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-teacher",
    attrs: {
      "to": {
        path: '/invitation/teacher'
      }
    }
  }), _vm._h('span', ["添加老师"])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-kids",
    attrs: {
      "to": {
        path: '/invitation/parents'
      }
    }
  }), _vm._h('span', ["添加学生 / 家长"])]), " ", (_vm.cookie_login_data.jobId == 1) ? _vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-hostcenter",
    attrs: {
      "to": {
        path: '/user/center/hostcenterApply'
      }
    }
  }), _vm._h('span', ["新建园点"])]) : _vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-hostcenter",
    attrs: {
      "to": {
        path: '/user/center/hostTeacherRegister'
      }
    }
  }), _vm._h('span', ["新建园点"])]), " ", " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-dynamic",
    attrs: {
      "to": {
        'path': '/dynamic/publish/0'
      }
    }
  }), _vm._h('span', ["发布动态"])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-food",
    attrs: {
      "to": {
        'path': '/dynamic/publish/1'
      }
    }
  }), _vm._h('span', ["发布伙食"])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "quick-rollcall",
    attrs: {
      "to": {
        path: '/rollcall/list'
      }
    }
  }), _vm._h('span', ["发起点名"])])]), " "]), " ", _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "bottom-bar"
  }, [_vm._h('a', {
    staticClass: "block text-center padding-15 font-16",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["取消"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-c6c013c2!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/quickAdd.vue
// module id = 223
// module chunks = 1